import type { ReactNode } from 'react';

import { PrimaryButton as _PrimaryButton, SecondaryButton as _SecondaryButton } from '@dot/design-system';
import { default as styled } from 'styled-components';

export const ButtonsGroup = styled.div`
  margin-top: 40px;
  display: flex;
  gap: 10px;
  justify-content: center;
`;

export type ButtonProps = {
  children?: ReactNode | undefined;
  onClick?: React.ComponentProps<typeof _PrimaryButton & typeof _SecondaryButton>['onClick'];
};

export const SecondaryButton = ({ children, onClick }: ButtonProps) => {
  return (
    <_SecondaryButton data-test-id="verification-result-secondary-btn" onClick={onClick}>
      {children}
    </_SecondaryButton>
  );
};

export const PrimaryButton = ({ children, onClick }: ButtonProps) => {
  return (
    <_PrimaryButton data-test-id="verification-result-primary-btn" onClick={onClick}>
      {children}
    </_PrimaryButton>
  );
};
